import React from 'react';

const copy = {
    ru: {
        selectLanguage: 'Выберите язык',
        language: 'Русский',
        scanQr: 'Сканировать QR код',
        balance: 'Баланс',
        wallet: 'Connect a Telegram Wallet',
        shops: 'Мои магазины',
        referrals: 'Мои рефералы',
        demo: 'Пример магазина',
        website: 'Наш сайт',
        channel: 'Наш канал',
        help: 'Нужна помощь?',
    },
    en: {
        selectLanguage: 'Select language',
        language: 'English',
        scanQr: 'Scan QR code',
        balance: 'Balance',
        wallet: 'Connect a Telegram Wallet',
        shops: 'My shops',
        referrals: 'My referrals',
        demo: 'Demo shop',
        website: 'Our website',
        channel: 'Our channel',
        help: 'Need help?',
    },
};

const languageNames = {
    ar: 'العربية',
    de: 'Deutsch',
    en: 'English',
    es: 'Español',
    fa: 'فارسی',
    fr: 'Français',
    he: 'עברית',
    it: 'Italiano',
    pl: 'Polski',
    pt: 'Português',
    ru: 'Русский',
    uk: 'Українська',
    uz: 'Oʻzbekcha',
    vi: 'Tiếng Việt',
    zh: '中文',
};

export function getConnectHomeCopy(languageCode, translate) {
    const normalizedLanguage = String(languageCode || 'en').toLowerCase().split(/[-_]/)[0];

    if (copy[normalizedLanguage]) {
        return copy[normalizedLanguage];
    }

    if (typeof translate !== 'function') {
        return copy.en;
    }

    return {
        selectLanguage: translate('select_language'),
        language: languageNames[normalizedLanguage] || normalizedLanguage.toUpperCase(),
        scanQr: translate('scan_qr'),
        balance: translate('balance'),
        wallet: 'Connect a Telegram Wallet',
        shops: translate('my_shops'),
        referrals: translate('my_refs'),
        demo: translate('demo_shop'),
        website: translate('out_website'),
        channel: translate('our_channel'),
        help: translate('help'),
    };
}

function IconSymbols() {
    return (
        <svg className="connect-startup-symbols" aria-hidden="true">
            <symbol id="startup-icon-language" viewBox="0 0 24 24">
                <circle cx="12" cy="12" r="7" fill="none" stroke="currentColor" strokeWidth="1.8" />
                <path d="M5 12h14M12 5c2 2.2 3 4.5 3 7s-1 4.8-3 7c-2-2.2-3-4.5-3-7s1-4.8 3-7Z" fill="none" stroke="currentColor" strokeWidth="1.4" />
            </symbol>
            <symbol id="startup-icon-qr" viewBox="0 0 24 24"><path d="M4 4h6v6H4V4Zm10 0h6v6h-6V4ZM4 14h6v6H4v-6Zm11 0h2v2h-2v-2Zm3 0h2v4h-2v-4Zm-4 4h4v2h-4v-2ZM6 6v2h2V6H6Zm10 0v2h2V6h-2ZM6 16v2h2v-2H6Z" /></symbol>
            <symbol id="startup-icon-ton" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10" /><path d="M7.2 7.4h9.6c.9 0 1.5 1 .9 1.8L12.8 17c-.4.7-1.2.7-1.6 0L6.3 9.2c-.6-.8 0-1.8.9-1.8Zm4 1.8H8.8l2.4 4.8V9.2Zm1.6 0V14l2.4-4.8h-2.4Z" fill="#fff" /></symbol>
            <symbol id="startup-icon-wallet" viewBox="0 0 24 24"><path d="M5 6.5h12.5A1.5 1.5 0 0 1 19 8v1h-4a3 3 0 0 0 0 6h4v1a1.5 1.5 0 0 1-1.5 1.5H5A2.5 2.5 0 0 1 2.5 15V9A2.5 2.5 0 0 1 5 6.5Zm10 4h5.5v3H15a1.5 1.5 0 1 1 0-3Zm.2 1.5a.7.7 0 1 0 1.4 0 .7.7 0 0 0-1.4 0Z" /></symbol>
            <symbol id="startup-icon-shops" viewBox="0 0 24 24"><path d="M4 5h16l-1.2 5.5a2.8 2.8 0 0 1-4.8 1.2 2.8 2.8 0 0 1-4 0 2.8 2.8 0 0 1-4.8-1.2L4 5Zm2 8.6c1.3.2 2.6-.2 3.5-1 .7.6 1.6.9 2.5.9s1.8-.3 2.5-.9c.9.8 2.2 1.2 3.5 1V19H6v-5.4Z" /></symbol>
            <symbol id="startup-icon-referrals" viewBox="0 0 24 24"><path d="M9 11a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm6.5-1a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5ZM3.5 18.5c0-3.2 2.4-5.5 5.5-5.5s5.5 2.3 5.5 5.5v.5h-11v-.5Zm10.2-5.2c.6-.2 1.2-.3 1.8-.3 2.8 0 5 2 5 4.8V19h-4.2v-.5c0-2.1-1-3.9-2.6-5.2Z" /></symbol>
            <symbol id="startup-icon-demo" viewBox="0 0 24 24"><path d="M7 7V5.8A4.8 4.8 0 0 1 11.8 1a4.8 4.8 0 0 1 4.8 4.8V7H20l-1 14H5L4 7h3Zm2 0h5.6V5.8a2.8 2.8 0 1 0-5.6 0V7Zm1.1 5.5 1.1 1.1 2.8-2.8 1.2 1.2-4 4-2.3-2.3 1.2-1.2Z" /></symbol>
            <symbol id="startup-icon-website" viewBox="0 0 24 24"><circle cx="12" cy="12" r="8" fill="none" stroke="currentColor" strokeWidth="2" /><path d="M4 12h16M12 4c2.3 2.4 3.3 5 3.3 8s-1 5.6-3.3 8c-2.3-2.4-3.3-5-3.3-8S9.7 6.4 12 4Z" fill="none" stroke="currentColor" strokeWidth="1.6" /></symbol>
            <symbol id="startup-icon-channel" viewBox="0 0 24 24"><path d="M3 10.5v3c0 1 .8 1.8 1.8 1.8h2.1l1.5 4.2a1.2 1.2 0 0 0 2.3-.8l-1.2-3.4H11l7 4.2V4.5l-7 4.2H4.8c-1 0-1.8.8-1.8 1.8Zm17-2.8h1v8.6h-1V7.7Z" /></symbol>
            <symbol id="startup-icon-help" viewBox="0 0 24 24"><path d="M5 4h14a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3h-8l-4.5 3v-3H5a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3Zm3.5 7.8a1.2 1.2 0 1 0 0-2.4 1.2 1.2 0 0 0 0 2.4Zm3.5 0a1.2 1.2 0 1 0 0-2.4 1.2 1.2 0 0 0 0 2.4Zm3.5 0a1.2 1.2 0 1 0 0-2.4 1.2 1.2 0 0 0 0 2.4Z" /></symbol>
        </svg>
    );
}

function HomeIcon({ type }) {
    return (
        <span className={`connect-startup-icon connect-startup-icon--${type}${type === 'qr' ? ' connect-startup-icon--plain' : ''}`} aria-hidden="true">
            <svg><use href={`#startup-icon-${type}`} /></svg>
        </span>
    );
}

function HomeRow({ action, icon, label, value, arrow = false, demo = false, ready, onAction }) {
    return (
        <button
            type="button"
            className="connect-startup-row connect-home-row"
            data-connect-action={action}
            disabled={!ready}
            onClick={ready ? onAction : undefined}
        >
            <HomeIcon type={icon} />
            <span className="connect-startup-label">{label}</span>
            {value !== undefined && value !== null && <span className="connect-startup-value">{value}</span>}
            {demo && <span className="connect-startup-eyes" aria-hidden="true">👀</span>}
            {arrow && <span className="connect-startup-arrow" aria-hidden="true" />}
        </button>
    );
}

export default function ConnectHomeShell({
    languageCode = 'en',
    labels = getConnectHomeCopy(languageCode),
    balance = 0,
    walletAddress = '',
    ready = false,
    actions = {},
}) {
    const numericBalance = Number.parseFloat(balance);
    const formattedBalance = `${Number.isFinite(numericBalance) ? numericBalance.toFixed(2) : '0.00'} TON`;
    const formattedWallet = walletAddress ? `${walletAddress.slice(0, 2)}...${walletAddress.slice(-4)}` : null;
    const action = (name) => actions[name] || (() => {});

    return (
        <div
            className="connect-startup connect-startup-final connect-home-shell"
            aria-busy={ready ? 'false' : 'true'}
            data-connect-ready={ready ? 'true' : 'false'}
            data-testid="connect-startup"
        >
            <IconSymbols />
            <div className="connect-startup-card connect-startup-card--first">
                <HomeRow action="language" icon="language" label={labels.selectLanguage} value={labels.language} ready={ready} onAction={action('language')} />
            </div>
            <div className="connect-startup-card">
                <HomeRow action="qr" icon="qr" label={labels.scanQr} arrow ready={ready} onAction={action('qr')} />
            </div>
            <div className="connect-startup-card">
                <HomeRow action="balance" icon="ton" label={labels.balance} value={formattedBalance} ready={ready} onAction={action('balance')} />
            </div>
            <div className="connect-startup-card">
                <HomeRow action="wallet" icon="wallet" label={labels.wallet} value={formattedWallet} arrow={!formattedWallet} ready={ready} onAction={action('wallet')} />
            </div>
            <div className="connect-startup-card">
                <HomeRow action="shops" icon="shops" label={labels.shops} arrow ready={ready} onAction={action('shops')} />
                <div className="connect-startup-divider" />
                <HomeRow action="referrals" icon="referrals" label={labels.referrals} arrow ready={ready} onAction={action('referrals')} />
                <div className="connect-startup-divider" />
                <HomeRow action="demo" icon="demo" label={labels.demo} demo ready={ready} onAction={action('demo')} />
            </div>
            <div className="connect-startup-card">
                <HomeRow action="website" icon="website" label={labels.website} arrow ready={ready} onAction={action('website')} />
                <div className="connect-startup-divider" />
                <HomeRow action="channel" icon="channel" label={labels.channel} arrow ready={ready} onAction={action('channel')} />
            </div>
            <div className="connect-startup-card">
                <HomeRow action="help" icon="help" label={labels.help} arrow ready={ready} onAction={action('help')} />
            </div>
            <footer className="connect-startup-footer">
                <div>Powered by <button type="button" className="connect-startup-link" disabled={!ready} onClick={ready ? action('channel') : undefined}>@webappz</button></div>
                <div>© 2023-<span id="connect-startup-year">{new Date().getFullYear()}</span></div>
            </footer>
        </div>
    );
}
